import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden pt-14 md:pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20fashion%20product%20photography%20featuring%20premium%20leather%20handbags%20and%20designer%20accessories%20artfully%20arranged%20on%20a%20warm%20terracotta%20textured%20surface%20with%20dried%20botanical%20elements%2C%20soft%20golden%20hour%20sunlight%20streaming%20diagonally%20creating%20long%20artistic%20shadows%2C%20rich%20warm%20earth%20tones%20palette%20with%20cognac%20brown%20and%20cream%20accents%2C%20luxury%20lifestyle%20magazine%20aesthetic%2C%20shallow%20depth%20of%20field%20on%20foreground%20elements%2C%20airy%20Mediterranean%20villa%20atmosphere%2C%20professional%20commercial%20fashion%20photography&width=1600&height=900&seq=yoybuy-hero-v2-2026&orientation=landscape"
          alt="Yoybuy Sheet fashion product showcase"
          title="Yoybuy Sheet — сравнение shopping-агентов Китая"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      </div>

      <div className={`relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4 md:mb-6">
          {t('hero_title')}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 text-base cursor-pointer"
          >
            <i className="ri-file-excel-2-line w-5 h-5 flex items-center justify-center"></i>
            {t('btn_yoybuy_sheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-white/90 hover:bg-white text-foreground-900 font-semibold rounded-full transition-all duration-300 text-base cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-shopping-cart-line w-5 h-5 flex items-center justify-center"></i>
            {t('btn_buy_now')}
          </a>
        </div>
      </div>
    </section>
  );
}